const axios = require("axios");

export const getVariable = async (variavel) => {
  var resp = await axios.get("/env.json");
  return resp.data[variavel];
};

export default axios;
